import { render } from "./InfoPopup.vue?vue&type=template&id=eba909b8&ts=true"
import script from "./InfoPopup.vue?vue&type=script&lang=ts"
export * from "./InfoPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__